import { useCallback, useRef } from 'react';
import type { PromotionFormProvince } from '../../../../stores/promotion';
import { SELECT_ALL_VALUE } from './use-construct-tree-data';

export const useHandleFormSelectionChange = () => {
    const knownBusinessUnitIds = useRef(new Map<number, number>());

    const handleProvinceSelectionChange = useCallback(
        (
            selectedProvinceIds: number[],
            currentFormProvinces: PromotionFormProvince[]
        ): PromotionFormProvince[] => {
            // Cache current mappings before processing
            for (const p of currentFormProvinces) {
                if (p.businessUnitId != null) {
                    knownBusinessUnitIds.current.set(
                        p.provinceId,
                        p.businessUnitId
                    );
                }
            }

            return selectedProvinceIds
                .filter(
                    (id) => ((id as unknown) as string) !== SELECT_ALL_VALUE
                )
                .map((provinceId) => ({
                    businessUnitId:
                        knownBusinessUnitIds.current.get(provinceId) ?? null,
                    provinceId,
                }));
        },
        []
    );

    return { handleProvinceSelectionChange };
};
